import React from "react";

import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/store/store";
import { setPostTab, setRankTab, setCompanyTab, setBlogTab } from "src/store/tab";

interface TabProp {
    tabs: string[];
    type?: string;
}

const Tab: React.FC<TabProp> = ({ tabs, type }) => {
    const dispatch = useDispatch();
    const tabType = useSelector((state: RootState) => {
        if (type === "/post") return state.tab.postTab;
        if (type === "/ranking") return state.tab.rankTab;
        if (type === "/securitiescompany") return state.tab.companyTab;
        if (type === "/blog") return state.tab.blogTab;
        return "";
    });

    const handleCategoryChange = (newTab: string) => {
        if (type === "/post") dispatch(setPostTab(newTab));
        if (type === "/ranking") dispatch(setRankTab(newTab));
        if (type === "/securitiescompany") dispatch(setCompanyTab(newTab));
        if (type === "/blog") dispatch(setBlogTab(newTab));
    };
    return (
        <div className="btn-wrap side_btn">
            {tabs.map((item, index) => (
                <React.Fragment key={index}>
                <button className={`btn${item === tabType ? " active" : ""}`} onClick={() => handleCategoryChange(item)}>
                    {item}
                </button>
                {index !== tabs.length - 1 && <small>|</small>}
                </React.Fragment>
            ))}
        </div>
    );
};
export default Tab;